<div class="page-header-container">
  <md-page-header [title]="byproductItem()?.name?.fi ?? ''" icon="product"></md-page-header>
  <md-info [item]="byproductItem()" [fields]="infoFields()" [pricingRouteLabel]="'INFO.GO_TO_PRICES'" [pricingType]="'byproduct'"> </md-info>
  <md-audit-trail [auditTrail]="auditTrail()"></md-audit-trail>
</div>
